import React, { useState, lazy, Component } from 'react';
import { motion } from 'framer-motion';
import { sendForm } from '../lib/sendForm';
import { MapPin, Phone, Mail, Send, CheckCircle2, MessageSquare, Users, Briefcase, ArrowRight } from 'lucide-react';
const offices = [{
  name: 'Head Office',
  region: 'Lekki, Lagos',
  address: '4A Omon Ebhomeyne Street, Off Admiralty Way, Lekki Phase 1, Lagos, Nigeria',
  phones: ['07034100972'],
  email: 'info@zylushomes.com',
  isHead: true
}, {
  name: 'Enugu Office',
  region: 'Enugu',
  address: '13, Umuawulu Street, Independence Layout, Enugu.',
  phones: ['08024691177'],
  email: 'Enuguoffice@zylusgroup.com',
  isHead: false
}, {
  name: 'Abeokuta Office',
  region: 'Ogun State',
  address: '3, Lagos-Abeokuta Expressway, Opposite Samdop Filling Station, Olomore, Abeokuta, Ogun State',
  phones: ['07061788986', '09152614872'],
  email: 'Zylus.abeokuta@gmail.com',
  isHead: false
}, {
  name: 'Mainland Corporate Office II',
  region: 'Ogba, Lagos',
  address: '375, Wempcro Road, Off Agidingbi, Ogba, Lagos',
  phones: ['09139249705'],
  email: '',
  isHead: false
}, {
  name: 'Mainland Corporate Office III',
  region: 'Ajao Estate, Lagos',
  address: '12/14 Adewunmi Abudu Street, Off Osolo Way, Ajao Estate, Lagos',
  phones: ['08136775252'],
  email: '',
  isHead: false
}, {
  name: 'Abuja Office',
  region: 'FCT',
  address: 'Abia House, Off Ahmadu Bello Way, Abuja.',
  phones: ['08188563947'],
  email: '',
  isHead: false
}];
export function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [source, setSource] = useState('');
  const [message, setMessage] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    await sendForm({
      formName: 'Contact Form',
      data: {
        'First Name': firstName,
        'Last Name': lastName,
        Email: contactEmail,
        Phone: phone,
        'How Did You Find Us': source,
        Message: message
      }
    });
    setIsSubmitting(false);
    setIsSuccess(true);
    setFirstName('');
    setLastName('');
    setContactEmail('');
    setPhone('');
    setSource('');
    setMessage('');
    setTimeout(() => setIsSuccess(false), 5000);
  };
  return <div className="pt-32 pb-24 bg-bone" data-id="element-1056">
      <div className="max-w-[1280px] mx-auto px-6 md:px-12" data-id="element-1057">
        {/* Hero / Form / Map */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start" data-id="element-1058">
          {/* Left: Headline + Form */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} data-id="element-1059">
            <h1 className="text-5xl md:text-6xl font-serif text-ink tracking-tight mb-5" data-id="element-1060">
              Get in <span className="text-gold" data-id="element-1061">Touch</span>
            </h1>
            <p className="text-ink/60 text-base leading-relaxed mb-3 max-w-lg" data-id="element-1062">
              Our friendly team would love to hear from you! Please fill out the
              form below and we will get back to you as soon as possible.
            </p>
            <p className="text-[11px] font-bold tracking-[0.2em] uppercase text-gold-dark mb-10" data-id="element-1063">
              Zylus Homes and Property — A Subsidiary of Zylus Group
            </p>

            <div className="bg-white rounded-3xl p-6 md:p-8 shadow-sm border border-ink/5 relative overflow-hidden" data-id="element-1064">
              {isSuccess && <div className="absolute inset-0 bg-white flex flex-col items-center justify-center text-center p-8 z-10" data-id="element-1065">
                  <motion.div initial={{
                scale: 0
              }} animate={{
                scale: 1
              }} transition={{
                type: 'spring',
                damping: 15
              }} className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mb-6" data-id="element-1066">
                    <CheckCircle2 className="w-10 h-10 text-green-500" data-id="element-1067" />
                  </motion.div>
                  <h3 className="text-3xl font-serif text-ink mb-3" data-id="element-1068">
                    Message Sent!
                  </h3>
                  <p className="text-ink/60 max-w-sm" data-id="element-1069">
                    Thank you for reaching out. A member of our team will get
                    back to you shortly.
                  </p>
                  <button onClick={() => setIsSuccess(false)} className="mt-8 text-sm font-semibold text-gold hover:text-gold-dark uppercase tracking-widest" data-id="element-1070">
                    Send another message
                  </button>
                </div>}

              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1071">
                <input required type="text" placeholder="First Name *" value={firstName} onChange={e => setFirstName(e.target.value)} className="w-full bg-bone/40 border border-ink/10 rounded-xl px-4 py-3.5 text-sm focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-all placeholder:text-ink/40" data-id="element-1072" />
                <input required type="text" placeholder="Last Name *" value={lastName} onChange={e => setLastName(e.target.value)} className="w-full bg-bone/40 border border-ink/10 rounded-xl px-4 py-3.5 text-sm focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-all placeholder:text-ink/40" data-id="element-1073" />
                <input type="email" placeholder="Email" value={contactEmail} onChange={e => setContactEmail(e.target.value)} className="w-full bg-bone/40 border border-ink/10 rounded-xl px-4 py-3.5 text-sm focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-all placeholder:text-ink/40" data-id="element-1074" />
                <input required type="tel" placeholder="Phone number *" value={phone} onChange={e => setPhone(e.target.value)} className="w-full bg-bone/40 border border-ink/10 rounded-xl px-4 py-3.5 text-sm focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-all placeholder:text-ink/40" data-id="element-1075" />
                <select value={source} onChange={e => setSource(e.target.value)} className="w-full bg-bone/40 border border-ink/10 rounded-xl px-4 py-3.5 text-sm focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-all text-ink/70" data-id="element-1076">
                  <option value="" disabled data-id="element-1077">
                    How did you find us?
                  </option>
                  <option value="Google Search" data-id="element-1078">Google Search</option>
                  <option value="Social Media" data-id="element-1079">Social Media</option>
                  <option value="Friend / Family" data-id="element-1080">Friend / Family</option>
                  <option value="Newspaper / Magazine" data-id="element-1081">
                    Newspaper / Magazine
                  </option>
                  <option value="Other" data-id="element-1082">Other</option>
                </select>
                <textarea rows={4} placeholder="Message" value={message} onChange={e => setMessage(e.target.value)} className="w-full bg-bone/40 border border-ink/10 rounded-xl px-4 py-3.5 text-sm focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-all resize-none placeholder:text-ink/40" data-id="element-1083" />

                <button type="submit" disabled={isSubmitting} className="w-full bg-gold hover:bg-gold-dark text-ink font-bold tracking-[0.25em] uppercase py-4 rounded-xl transition-colors flex items-center justify-center gap-2 disabled:opacity-70 mt-2" data-id="element-1084">
                  {isSubmitting ? 'Sending...' : 'Send'}
                  {!isSubmitting && <Send className="w-4 h-4" data-id="element-1085" />}
                </button>
              </form>
            </div>
          </motion.div>

          {/* Right: Map */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} className="lg:sticky lg:top-32" data-id="element-1086">
            <div className="w-full h-[500px] lg:h-[580px] bg-ink/5 rounded-3xl overflow-hidden border border-ink/5 shadow-sm" data-id="element-1087">
              <iframe title="Zylus Head Office — Lekki Phase 1" width="100%" height="100%" frameBorder="0" style={{
              border: 0
            }} src="https://www.google.com/maps?q=4A+Omon+Ebhomeyne+Street,+Off+Admiralty+Way,+Lekki+Phase+1,+Lagos,+Nigeria&output=embed" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-1088" />
            </div>

            <a href="https://www.google.com/maps/search/?api=1&query=4A+Omon+Ebhomeyne+Street,+Off+Admiralty+Way,+Lekki+Phase+1,+Lagos,+Nigeria" target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-2 bg-ink hover:bg-ink/90 text-white text-sm font-semibold px-6 py-3.5 rounded-xl transition-colors w-full justify-center group" data-id="element-1089">
              <MapPin className="w-4 h-4 text-gold" data-id="element-1090" />
              Open in Google Maps for Directions
              <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" data-id="element-1091" />
            </a>

            <div className="mt-3 text-xs text-ink/50 text-center px-4" data-id="element-1092">
              Head Office · 4A Omon Ebhomeyne Street, Off Admiralty Way, Lekki
              Phase 1, Lagos
            </div>
          </motion.div>
        </div>

        {/* Our Offices */}
        <div className="mt-24" data-id="element-1093">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12" data-id="element-1094">
            <div data-id="element-1095">
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="text-[11px] font-bold tracking-[0.25em] uppercase text-gold mb-3" data-id="element-1096">
                Our Offices
              </motion.div>
              <motion.h2 initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="text-4xl md:text-5xl font-serif text-ink tracking-tight" data-id="element-1097">
                Visit us across Nigeria
              </motion.h2>
            </div>
            <p className="text-ink/60 text-sm max-w-sm" data-id="element-1098">
              Six locations and growing — find the Zylus office nearest to you.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1099">
            {offices.map((office, i) => <motion.div key={office.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i % 3 * 0.08,
            duration: 0.5
          }} whileHover={{
            y: -6
          }} className="group relative bg-white rounded-3xl p-7 border border-ink/5 hover:shadow-2xl hover:border-gold/40 transition-all duration-500 flex flex-col overflow-hidden" data-id="element-1100">
                <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-gold/15 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none" data-id="element-1101" />
                <div className="absolute bottom-0 left-0 h-[3px] bg-gold w-0 group-hover:w-full transition-all duration-500 ease-out" data-id="element-1102" />

                {office.isHead && <span className="self-start mb-4 inline-flex items-center gap-1.5 bg-gold text-ink text-[9px] font-bold tracking-[0.2em] uppercase px-2.5 py-1 rounded-full" data-id="element-1103">
                    <span className="w-1 h-1 rounded-full bg-ink" data-id="element-1104" />
                    Head Office
                  </span>}

                <div className="flex items-start gap-3 mb-5 relative" data-id="element-1105">
                  <motion.div whileHover={{
                rotate: -8,
                scale: 1.08
              }} className="w-9 h-9 rounded-xl bg-gold/10 flex items-center justify-center shrink-0 mt-0.5 group-hover:bg-gold transition-colors duration-500" data-id="element-1106">
                    <MapPin className="w-4 h-4 text-gold-dark group-hover:text-ink transition-colors duration-500" data-id="element-1107" />
                  </motion.div>
                  <div data-id="element-1108">
                    <h4 className="text-xl font-serif text-ink leading-tight" data-id="element-1109">
                      {office.name}
                    </h4>
                    <div className="text-[10px] font-bold uppercase tracking-widest text-ink/40 mt-1" data-id="element-1110">
                      {office.region}
                    </div>
                  </div>
                </div>

                <p className="text-sm text-ink/70 leading-relaxed mb-6 flex-grow" data-id="element-1111">
                  {office.address}
                </p>

                <div className="space-y-2.5 pt-5 border-t border-ink/5" data-id="element-1112">
                  {office.phones.map(p => <a key={p} href={`tel:${p.replace(/\s/g, '')}`} className="flex items-center gap-2.5 text-sm text-ink/80 hover:text-gold transition-colors" data-id="element-1113">
                      <Phone className="w-3.5 h-3.5 text-gold shrink-0" data-id="element-1114" />
                      {p}
                    </a>)}
                  {office.email && <a href={`mailto:${office.email}`} className="flex items-center gap-2.5 text-sm text-ink/80 hover:text-gold transition-colors break-all" data-id="element-1115">
                      <Mail className="w-3.5 h-3.5 text-gold shrink-0" data-id="element-1116" />
                      {office.email}
                    </a>}
                </div>

                <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(office.address)}`} target="_blank" rel="noreferrer" className="mt-5 text-xs font-semibold text-gold hover:text-gold-dark flex items-center gap-1.5 group/link" data-id="element-1117">
                  Get directions
                  <ArrowRight className="w-3.5 h-3.5 group-hover/link:translate-x-0.5 transition-transform" data-id="element-1118" />
                </a>
              </motion.div>)}
          </div>
        </div>

        {/* "We would love to hear from you" section */}
        <div className="mt-24 text-center" data-id="element-1119">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[11px] font-bold tracking-[0.25em] uppercase text-gold mb-4" data-id="element-1120">
            Contact Us
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-serif text-ink tracking-tight mb-4" data-id="element-1121">
            We would love to hear from you
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-ink/60 mb-16" data-id="element-1122">
            Chat to our friendly team
          </motion.p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left" data-id="element-1123">
            {[{
            icon: MessageSquare,
            title: 'Sales & Enquiries',
            desc: 'Speak to our property consultants about available estates and payment plans.',
            cta: 'Chat with Sales',
            email: 'sales@zylushomes.com'
          }, {
            icon: Users,
            title: 'Customer Support',
            desc: 'Existing client? Get help with your documentation, payments, or general support.',
            cta: 'Contact Support',
            email: 'support@zylushomes.com'
          }, {
            icon: Briefcase,
            title: 'Partnerships',
            desc: "Interested in becoming a realtor or exploring B2B opportunities? Let's talk.",
            cta: 'Partner with us',
            email: 'partners@zylushomes.com'
          }].map((card, i) => {
            const Icon = card.icon;
            return <motion.a key={card.title} href={`mailto:${card.email}`} initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1,
              duration: 0.6,
              ease: [0.16, 1, 0.3, 1]
            }} whileHover={{
              y: -8
            }} className="group relative bg-white p-8 rounded-3xl border border-ink/5 hover:border-gold/40 hover:shadow-2xl transition-all duration-500 flex flex-col overflow-hidden" data-id="element-1124">
                  {/* Gold glow on hover */}
                  <div className="absolute -top-20 -right-20 w-48 h-48 rounded-full bg-gold/20 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none" data-id="element-1125" />

                  <motion.div className="relative w-14 h-14 rounded-2xl bg-gold/10 flex items-center justify-center mb-6 group-hover:bg-gold transition-colors duration-500" whileHover={{
                rotate: 6,
                scale: 1.05
              }} data-id="element-1126">
                    <Icon className="w-6 h-6 text-gold-dark group-hover:text-ink transition-colors duration-500" data-id="element-1127" />
                  </motion.div>

                  <h4 className="text-xl font-serif text-ink mb-2 relative" data-id="element-1128">
                    {card.title}
                  </h4>
                  <p className="text-sm text-ink/60 mb-6 relative flex-grow" data-id="element-1129">
                    {card.desc}
                  </p>
                  <span className="text-sm font-semibold text-gold flex items-center gap-2 relative" data-id="element-1130">
                    {card.cta}
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1.5 transition-transform duration-300" data-id="element-1131" />
                  </span>

                  {/* Bottom accent line */}
                  <div className="absolute bottom-0 left-0 h-[3px] bg-gold w-0 group-hover:w-full transition-all duration-500 ease-out" data-id="element-1132" />
                </motion.a>;
          })}
          </div>

          {/* Quick info row */}
          <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-4 text-left" data-id="element-1133">
            {[{
            icon: Phone,
            label: 'Call Us',
            value: '07061032706',
            href: 'tel:07061032706'
          }, {
            icon: Mail,
            label: 'Email Us',
            value: 'info@zylushomes.com',
            href: 'mailto:info@zylushomes.com'
          }, {
            icon: MapPin,
            label: 'Visit Us',
            value: '4A Omon Ebhomeyne Street, Off Admiralty Way, Lekki Phase 1, Lagos, Nigeria',
            href: 'https://www.google.com/maps/search/?api=1&query=4A+Omon+Ebhomeyne+Street,+Off+Admiralty+Way,+Lekki+Phase+1,+Lagos,+Nigeria',
            external: true
          }].map((item, i) => {
            const Icon = item.icon;
            return <motion.a key={item.label} href={item.href} target={item.external ? '_blank' : undefined} rel={item.external ? 'noreferrer' : undefined} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1,
              duration: 0.5
            }} whileHover={{
              y: -4
            }} className="group bg-white p-6 rounded-2xl border border-ink/5 hover:border-gold/40 hover:shadow-xl transition-all duration-500 flex items-center gap-4" data-id="element-1134">
                  <motion.div whileHover={{
                rotate: -10,
                scale: 1.1
              }} className="w-11 h-11 rounded-full bg-gold/10 flex items-center justify-center shrink-0 group-hover:bg-gold transition-colors duration-500" data-id="element-1135">
                    <Icon className="w-5 h-5 text-gold-dark group-hover:text-ink transition-colors duration-500" data-id="element-1136" />
                  </motion.div>
                  <div className="min-w-0" data-id="element-1137">
                    <div className="text-[10px] font-bold uppercase tracking-wider text-ink/50 mb-0.5" data-id="element-1138">
                      {item.label}
                    </div>
                    <div className="text-sm font-medium text-ink leading-relaxed group-hover:text-gold-dark transition-colors" data-id="element-1139">
                      {item.value}
                    </div>
                  </div>
                </motion.a>;
          })}
          </div>
        </div>
      </div>
    </div>;
}